import { render, staticRenderFns } from "./OpenAuthRedirectTarget.vue?vue&type=template&id=380aeaef&scoped=true"
import script from "./OpenAuthRedirectTarget.vue?vue&type=script&lang=js"
export * from "./OpenAuthRedirectTarget.vue?vue&type=script&lang=js"
import style0 from "./OpenAuthRedirectTarget.vue?vue&type=style&index=0&id=380aeaef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380aeaef",
  null
  
)

export default component.exports